// extracted by mini-css-extract-plugin
export default {"container":"yj-z","blurb":"zj-z","links":"Aj-z"};